module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: _vm.classes,
    attrs: {
      "type": _vm.htmlType,
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm._handleClick
    }
  }, [(_vm.loading) ? _c('t-icon', {
    class: ((_vm.$constants.PREFIX_ICON_CLASS) + "ani-loop"),
    attrs: {
      "type": "loading"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon && !_vm.loading) ? _c('t-icon', {
    attrs: {
      "type": _vm.icon
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSlot) ? _c('span', {
    ref: "slot"
  }, [_vm._t("default")], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-353798ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/button/button.vue
// module id = 358
// module chunks = 0